module.exports = __webpack_public_path__ + "static/project3-b379b72af76548ddc83fe7b323f7b067.png";